module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"remote-supply-voltage":"Fernspeisespannung","remote-supply-measurement":"Fernspeisestrom messen"},"en":{"remote-supply-voltage":"Remote Supply Voltage","remote-supply-measurement":"Measure Remote Supply Current"}}')
  delete Component.options._Ctor
}
